










































































































































import { Component, Watch } from 'vue-property-decorator';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Camaras/Alertas/FiltrosBusqueda.vue';
import VerDetalleModal from './VerDetalleModal.vue';
import WidgetAlerta from '@/pantallas/Camaras/Alertas/WidgetAlerta.vue';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import { actionsEvent } from '@/setup';
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import moment from 'moment';
import showImage from '@/pantallas/Camaras/Alertas/showImage.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { fetchReportesSerie } from './fetchReporteSerie';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import {
  codigoAccionesMenuItem,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import { getUserId } from '../MantenedorLocalidad/helpers/getUserId';
import PopUpGeneratedReports from './PopUpGeneratedReports.vue';

@Component({
  components: {
    MantenedorGridSinCodigo,
    GridComponent: AgGridVue,
    FiltrosBusqueda,
    VerDetalleModal,
    WidgetAlerta,
    showImage,
    FormFieldsContainer,
    DatePicker,
    PopUpGeneratedReports,
  },
})
export default class ModuloAutorizacionBase extends ComponenteBase {
  readonly codigoAccionesMenuItem = Object.values(codigoAccionesMenuItem);
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.ModuloAutorizaciones;

  loadingService = new LoadingService();
  filtrobusquedagrilla: string = '';
  mostrarModalVerDetalle: boolean = false;

  columnApi: any = null;
  gridEvent: any = null;
  serverSide: any = null;
  gridApi: GridApi = null;
  showReporteGenerado: boolean = false;
  texto_reporte: string = '';
  ordesList: any[] = [];
  equiposlist: any[] = [];

  racklist: any[] = [];
  moduloList: any[] = [];
  bloquelist: any[] = [];
  usuarioList: any = [];

  msgReport: string = '';
  showPopUpReport: boolean = false;

  usuarioID: any = '';
  pagina: number = 1;
  cant_regs_pag: number = 25;
  estadoList: any[] = [
    { text: 'Pendiente', value: null },
    { text: 'Aprobado', value: true },
    { text: 'Rechazado', value: false },
  ];
  @Watch('dataReady')
  loadReady() {
    this.filtroRequerimiento(true);
  }
  async getEquipos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      { '': '' },
      'conecta_autorizaciones/get_grilla_filters'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.moduloList = data.data.MODULO;
          self.usuarioList = data.data.USUARIO;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'No. de Autorización',
        field: 'Autorización',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 135,
      },
      {
        headerName: 'Operación',
        field: 'Tipo de Movimiento',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'No. Operación',
        field: 'Número de Movimiento',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Fecha de Solicitud',
        field: 'Fecha de Solicitud',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        valueFormatter: function(params) {
          return moment(params.value).format('YYYY/MM/DD HH:mm:ss');
        },
      },
      {
        headerName: 'RUT Usuario',
        field: 'RUT Usuario',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Solicitante',
        field: 'Nombre',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Mail',
        field: 'Mail',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'Observación',
        field: 'Observación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'Estado Autorizador',
        field: 'Estado Autorizador',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 135,
      },
      {
        headerName: 'Estado Solicitud',
        field: 'Estado Solicitud',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 135,
      },

      {
        headerName: 'Fecha Revisión',
        field: 'Fecha Revisión',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 135,
        valueFormatter: function(params) {
          return moment(params.value).format('YYYY/MM/DD HH:mm:ss');
        },
      },

      {
        headerName: 'Comentario',
        field: 'Comentario',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
    ],

    pagination: true,
    paginationPageSize: this.cant_regs_pag,
    cacheBlockSize: this.cant_regs_pag,
    paginationAutoPageSize: false,
    rowModelType: 'serverSide',
    //serverSideDatasource: this.serverSide,
    onGridReady: this.handleGridReady,
    overlayNoRowsTemplate: 'No hay filas para mostrar',
  };

  formFields: FormFieldDefMap = {
    modulo: {
      label: 'Operación',
      id: '',
      value: '',
    },
    fechaSolicitudInicio: {
      label: 'Fecha de Solicitud Inicio',
      id: 'fechaingreso',
      value: moment()
        .subtract(1, 'month')
        .startOf('day')
        .hour(1),
    },
    fechaSolicitudFin: {
      label: 'Fecha de Solicitud Fin',
      id: 'fechaingreso',
      value: moment()
        .startOf('day')
        .hour(12),
    },
    solicitante: {
      label: 'Solicitante',
      id: '',
      value: '',
    },
    estado: {
      label: 'Estado Autorizador',
      id: '',
      value: '',
    },
    TipoEquipo: {
      label: 'Tipo de Equipo',
      id: '',
      value: '',
    },
    operacion: {
      label: 'No. Operación',
      id: '',
      value: '',
    },
    rack: {
      label: 'Rack',
      id: '',
      value: '',
    },
    Bloque: {
      label: 'Bloque',
      id: '',
      value: '',
    },
  };
  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }
  handleBuscarClick() {
    this.filtroRequerimiento(true);
  }
  get fechaMaximaInicio() {
    //let fechaMax = this.formFields.fechaInicio.value;

    return moment(this.fechaMaxima) as moment.Moment;
    //return fechaMax as moment.Moment;
  }

  async clearFilters() {
    this.formFields.modulo.value = undefined;
    this.formFields.estado.value = undefined;
    this.formFields.solicitante.value = undefined;
    this.formFields.operacion.value = undefined;
    this.formFields.fechaSolicitudInicio.value = moment()
      .subtract(1, 'month')
      .startOf('day')
      .hour(1);
    this.formFields.fechaSolicitudFin.value = moment()
      .startOf('day')
      .hour(12);
    this.handleBuscarClick();
  }
  dataReady: boolean = false;
  async handleGridReady(event: GridReadyEvent) {
    this.usuarioID = JSON.parse(localStorage.getItem('user')).id;
    this.gridApi = event.api;
    this.gridApi.setDomLayout('autoHeight');
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.usuarioID = JSON.parse(localStorage.getItem('user')).id;
    let self = this;
    this.serverSide = {
      async getRows(event: any): Promise<void> {
        let body: any = self.filtros2body();
        event.request.paginationSize = self.gridOptions.cacheBlockSize;
        self.pagina = Math.ceil(
          event.request.startRow / self.cant_regs_pag + 1
        );

        body.pagina = self.pagina;
        (body.usuarioID = JSON.parse(localStorage.getItem('user')).id),
          await fetchReportesSerie(
            {
              body,
            },
            'conecta_autorizaciones/get_filtered_rs'
          )
            .then((response: any) => {
              if (response.data.CODIGO_RESPUESTA == '1') {
                if (response.data.data.length === 0) {
                  self.$snotify.error('Sin registros', { timeout: 3000 });
                  event.successCallback([{}], 0);
                  self.gridApi.showNoRowsOverlay();
                } else {
                  event.successCallback(
                    response.data.data.LISTA,
                    Number(response.data.cant_regs_pag.TOTAL_REGISTROS)
                  );
                  self.gridApi.hideOverlay();
                  self.autoSizeAll(true);
                }
              } else {
                event.successCallback([{}], 0);
                self.$snotify.error(response.data.MENSAJE_RESPUESTA, {
                  timeout: 3000,
                });
              }
            })
            .catch((error: any) => {
              event.successCallback([{}], 0);
              self.$snotify.error('Sin Registros', {
                timeout: 3000,
              });
            })
            .finally(() => {
              self.gridApi.setDomLayout('autoHeight');
            });
      },
    };
    this.dataReady = true;
    this.getEquipos();
  }

  autoSizeAll(skipHeader: boolean) {
    this.columnApi.autoSizeColumns(
      this.columnApi.getAllDisplayedColumns().map((x: any) => x.colId)
    );
  }
  //Busca dentro del resultado de la grilla
  searchData() {
    this.gridApi.setQuickFilter(this.filtrobusquedagrilla);
    this.gridApi.setDomLayout('autoHeight');
  }

  //evita el click derecho
  handlerContexTmenu(e: any) {
    e.preventDefault();
  }

  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionConsultar];

  constructor() {
    super();
    actionsEvent.onVerDetalle(this.handleVerDetalleClick);
  }
  params: any = '';
  handleVerDetalleClick(params: ICellRendererParams) {
    this.params = params.data;

    this.mostrarModalVerDetalle = true;
  }
  handleCierreModalVerDetalle() {
    this.handleBuscarClick();
    this.mostrarModalVerDetalle = false;
  }

  filtros2body() {
    let body: any = {};
    body.modulo = this.formFields.modulo.value
      ? this.formFields.modulo.value
      : '';
    body.fechaSolicitudInicio = moment(
      String(this.formFields.fechaSolicitudInicio.value)
    ).format('YYYY/MM/DD HH:MM:SS')
      ? this.formFields.fechaSolicitudInicio.value
      : '';
    body.fechaSolicitudFin = moment(
      String(this.formFields.fechaSolicitudFin.value)
    ).format('YYYY/MM/DD HH:MM:SS')
      ? this.formFields.fechaSolicitudFin.value
      : '';
    body.solicitante = this.formFields.solicitante.value
      ? this.formFields.solicitante.value
      : '';
    body.operacion = this.formFields.operacion.value
      ? this.formFields.operacion.value
      : '';
    body.estado =
      this.formFields.estado.value !== undefined
        ? this.formFields.estado.value
        : '';

    return body;
  }

  filtroRequerimiento(loadWidget: boolean) {
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  findFilter({ paramsApi, list, id, propName, category }: any): string {
    const obj = list.find((item: any) => item[id] === paramsApi[category]);
    return obj ? obj[propName] : '';
  }

  handleCloseReport(): void {
    this.showPopUpReport = false;
    this.msgReport = '';
  }

  async getCSV(): Promise<void> {
    const paramsApi = this.filtros2body();
    const filter: Record<string, string> = {};

    const findItem: any = {
      modulo: [this.moduloList, 'configid', 'configdescripcion'],
      solicitante: [this.usuarioList, 'usuarioid_alta', 'nombre'],
      estado: [this.estadoList, 'value', 'text'],
    };

    for (const category in findItem) {
      if (!['', undefined].includes(paramsApi[category])) {
        const [list, id, propName] = findItem[category];
        filter[propName] = this.findFilter({
          paramsApi,
          list,
          id,
          propName,
          category,
        });
      }
    }

    const userId = getUserId();
    const user = localStorage.getItem('clienteDefecto');
    this.loadingService.showLoading();
    const self: this = this;

    return await fetchReportesSerie(
      {
        userId,
        user,
        ...paramsApi,
        ...filter,
      },
      'conecta_autorizaciones/export_excel'
    )
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = response.data;
        if (CODIGO_RESPUESTA != '1') {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3500 });
          return;
        }
        self.msgReport = MENSAJE_RESPUESTA;
        self.showPopUpReport = true;
      })
      .catch((error: Error) => {
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3500 }
        );
        throw error;
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }
}
